import { createContext, useState, useContext } from 'react'

const AudioContext = createContext()

export function AudioProvider({ children }) {
  const [playingAudioId, setPlayingAudioId] = useState(null)

  return (
    <AudioContext.Provider value={{ playingAudioId, setPlayingAudioId }}>
      {children}
    </AudioContext.Provider>
  )
}

export function useAudio() {
  const context = useContext(AudioContext)
  if (!context) {
    throw new Error('useAudio must be used within an AudioProvider')
  }
  return context
}
